import { create } from 'zustand';
import { shallow } from 'zustand/shallow';
import { BffGamesCategory } from '@lucky7ventures/bff-types';

export const GIG_GAMES_CATEGORIES_RECORD: Partial<Record<BffGamesCategory, string>> = {
  'last-played': 'games.categories.lastPlayed',
  recommended: 'games.categories.recommended',
  'winter-games': 'games.categories.winterGames',
  'new-games': 'games.categories.newGames',
  'live-casino': 'games.categories.liveCasino',
  slots: 'games.categories.slots',
  jackpots: 'games.categories.jackpots',
  'table-games': 'games.categories.tableGames',
  'all-games': 'games.categories.allGames',
};

export interface GamesCategoryNavStore {
  feature?: BffGamesCategory;
  provider?: string;
  category?: BffGamesCategory;
}

type GamesCategoryNavActions = {
  setFeature: (feature?: BffGamesCategory) => void;
  setProvider: (provider?: string) => void;
  setCategory: (category?: BffGamesCategory) => void;
  reset: () => void;
};

type State = GamesCategoryNavStore;

const initialState: State = {
  feature: undefined,
  provider: undefined,
  category: undefined,
};

export const useGameCategoryNavStore = create<{ data: State } & GamesCategoryNavActions>(set => ({
  data: initialState,
  setFeature: (feature?: BffGamesCategory) => set(state => ({ data: { ...state.data, feature } })),
  setProvider: (provider?: string) => set(state => ({ data: { ...state.data, provider } })),
  setCategory: (category?: BffGamesCategory) =>
    set(state => ({ data: { ...state.data, category } })),
  reset: () => set({ data: initialState }),
}));

export const useGameCategoryNavData = () => {
  return useGameCategoryNavStore(state => state.data, shallow);
};

export const useGameCategoryNavActions = () => {
  return useGameCategoryNavStore(
    state => ({
      setFeature: state.setFeature,
      setProvider: state.setProvider,
      setCategory: state.setCategory,
      reset: state.reset,
    }),
    shallow,
  );
};
